<template>
    <div>
            <z-title title="会员卡类别设置" ref="title"></z-title>
            <el-card class="content1" ref="search">
                <div class="flex-n fac fjb ">

                <div class="flex-n fac">
                    <div class="textnowrap">类别：</div>
                    <card-type-code class="mr-10" clearable size="medium" v-model="cardType"
                                    placeholder="全部"></card-type-code>

                    <el-input
                            size="medium"
                            class="ele-input mr-10"
                            placeholder="类别名称"
                            maxlength="8"
                            clearable
                            title="输入类别名称"
                            prefix-icon="el-icon-search"
                            v-model="cardName">
                    </el-input>
                </div>
                <div class="flex-n fac">
                    <el-button type="primary" class="ele-btn2" @click="searchCard">查询</el-button>
                    <el-button type="primary" class="ele-btn2" @click="addCard">新增</el-button>
                </div>
                </div>
            </el-card>
            <el-card class="mt-10">
                <el-table
                        v-loading="loading"
                        :height="height+'px'"
                        highlight-current-row
                        element-loading-text="列表刷新中"
                        header-cell-class-name="headerrow"
                        cell-class-name="cellclass"
                        :data="dataList"
                        style="width: 100%">
                    <el-table-column
                            fixed
                            align="center"
                            prop="cardTypeName"
                            label="类 别"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="memberCardName"
                            label="类别名称"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="规 则"
                            align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.cardType=='01'">
                                {{scope.row.cardRule}}
                            </template>
                            <template v-else>
                                {{scope.row.discount}}折
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备 注"
                            min-width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="130"
                            align="center">
                        <template slot-scope="scope">
                            <div style="margin: 5px 0">
                                <el-button type="primary" class="ele-btn-small" @click="editCard(scope.row.id)">编辑
                                </el-button>
                                <el-button type="primary" class="ele-btn-small" @click="delCard(scope.row.id)">删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                            @currentChange="handleCurrentChange"></pagination>
            </el-card>
            <!--新增 编辑-->
            <el-dialog :visible.sync="showdialog" class="doedit" width="760px"  v-loading="addloading"  element-loading-text="提交中……" :close-on-click-modal="false">
                <div slot="title">
                    <z-title :title="editstate+'会员卡类别'"></z-title>
                </div>
                <div class="rulefrom2">

                    <!--订单确认收款-->
                    <el-form :model="dataForm" :rules="rules" ref="ruleForm" class=" mt-10">
                        <el-form-item label="类别名称" :show-message="false" prop="memberCardName" label-width="80px">
                            <el-input placeholder="请输入类别名称" class="w-220" v-model="dataForm.memberCardName"></el-input>
                        </el-form-item>
                        <el-form-item label="类 别" :show-message="false" prop="cardType" label-width="80px">
                            <card-type-code class="w-220" clearable size="medium" v-model="dataForm.cardType"
                                            placeholder="请选择类别"></card-type-code>
                        </el-form-item>
                        <template v-if="dataForm.cardType=='01'">
                        <el-form-item label="充值金额" :show-message="false" prop="rechargeMoney" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="￥" class="w-220 mr-10" v-model="dataForm.rechargeMoney"
                                          v-number="{precision:2}">
                                </el-input>
                                <div>元</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="到账金额" :show-message="false" prop="receiveMoney" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="￥" class="w-220 mr-10" v-model="dataForm.receiveMoney"
                                          v-number="{precision:2}">
                                </el-input>
                                <div>元</div>
                            </div>
                        </el-form-item>
                        </template>
                        <!--折扣卡只有折扣-->
                        <el-form-item label="折 扣" prop="discount" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="￥" class="w-220 mr-10" v-model="dataForm.discount"
                                          v-number="{precision:2,max:10}">
                                </el-input>
                                <div>折</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="备 注" prop="remark" label-width="80px">
                            <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                      maxlength="512"></el-input>
                        </el-form-item>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                            <el-button @click="showdialog=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import WantHouse from "../../components/data/wantHouse";
    import CardTypeCode from "../../components/data/cardTypeCode";
    import CardStateCode from "../../components/data/cardStateCode";
    import ElCard from "element-ui/packages/card/src/main";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ElCard,
            CardStateCode,
            CardTypeCode,
            WantHouse,
            ZTitle
        },
        name: "category",
        data() {
            return {
                addloading:false,
                loading: false,
                pageSize: 20,
                height:250,
                currentPage: 1,
                total: 0,
                dataForm: {
                    cardType:'01'
                },
                id: '',
                editstate: '新增',
                dataList: [],
                rules: {
                    memberCardName: [{required: true, trigger: 'blur'}],
                    cardType: [{required: true, trigger: 'change'}],

                    rechargeMoney: [{required: true, trigger: 'change'}],
                    receiveMoney: [{required: true,  trigger: 'change'}],

                },
                name: '',
                date: '',
                showdialog: false,
                showinfo: true,
                cardType: '',
                cardName: ''
            }
        },
        watch: {
            showdialog(newval, oldval) {
                if (!newval) {
                    this.$refs.ruleForm.resetFields();
                }
            }
        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
          this.getCard();
        },
        methods: {
            //查询会员信息列表
            getCard() {
                this.loading = true;
                this.$axios.post('/card/cardList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "cardType": this.cardType,
                    "cardName": this.cardName,
                    "currentPage": this.currentPage,
                    "pageSize": this.pageSize,
                }).then(res => {
                    console.log('会员类别列表', res);
                    var dataList = res.data.list;
                    this.dataList = dataList;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchCard() {
                this.currentPage = 1;
                this.getCard();
            },
            //添加
            addCard() {
                this.showdialog = true;
                this.editstate = '新增'
            },
            //编辑
            editCard(id) {
                console.log('编辑', id)
                this.id = id;
                this.showdialog = true;
                this.editstate = '编辑';
                this.$axios.get('/card/cardById/' + id).then(res => {
                    console.log(res)
                    this.dataForm = res.data;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //删除
            delCard(id) {
                this.$axios.post('/card/cardDeleteById', id).then(res => {
                    this.$message.success('删除会员卡类别成功！');
                    this.getCard();
                }).catch(err => {
                    this.$message.error(err.msg);
                })

            },
            //添加提交
            addSubmit() {
                let dataForm = this.dataForm;
                this.$axios.post('/card/cardAdd', {
                    "storeId": this.$root.getStorage('storeId'),
                    "memberCardName": dataForm.memberCardName,
                    "cardType": dataForm.cardType,
                    "cardTypeName": dataForm.cardTypeName,
                    "rechargeMoney": dataForm.rechargeMoney,
                    "receiveMoney": dataForm.receiveMoney,
                    "discount": dataForm.discount,
                    "companyId": dataForm.companyId,
                    "remark": dataForm.remark
                }).then(res => {
                    this.addloading=false;
                    this.currentPage = 1;
                    this.getCard();
                    this.$message.success('新增会员卡类别成功！');
                    this.showdialog = false;
                }).catch(err => {
                    this.addloading=false;
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit() {
                let dataForm = this.dataForm;
                this.$axios.post('/card/cardUpdate', {
                    "id":this.id,
                    "storeId": this.$root.getStorage('storeId'),
                    "memberCardName": dataForm.memberCardName,
                    "cardType": dataForm.cardType,
                    "cardTypeName": dataForm.cardTypeName,
                    "rechargeMoney": dataForm.rechargeMoney,
                    "receiveMoney": dataForm.receiveMoney,
                    "discount": dataForm.discount,
                    "companyId": dataForm.companyId,
                    "remark": dataForm.remark
                }).then(res => {
                    this.addloading=false;
                    this.$message.success('编辑会员成功！');
                    this.getCard();
                    this.showdialog = false;
                }).catch(err => {
                    this.addloading=false;
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addloading=true;
                        if (this.editstate == '新增') {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getCard();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getCard();
                console.log(`当前页: ${val}`);
            },
        }
    }
</script>

<style scoped>

</style>